import { ChangeDetectionStrategy, Component, effect, Injector, inject, input, output, untracked } from '@angular/core';
import {
    areEstimatorIntroductionStatesEqual,
    ESTIMATOR_INTRODUCTION_INITIAL_STATE,
} from './cost-to-build-client-ui-estimator-introduction.state';
import { EstimatorIntroductionStore } from './cost-to-build-client-ui-estimator-introduction.store';
import type { EstimatorIntroductionState } from './cost-to-build-client-ui-estimator-introduction.types';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    providers: [EstimatorIntroductionStore],
    selector: 'ctb-estimator-introduction',
    styleUrl: './cost-to-build-client-ui-estimator-introduction.scss',
    templateUrl: './cost-to-build-client-ui-estimator-introduction.html',
})
export class CtbEstimatorIntroductionComponent {
    readonly #injector = inject(Injector);
    readonly #store = inject(EstimatorIntroductionStore);

    readonly description = input<string>(ESTIMATOR_INTRODUCTION_INITIAL_STATE.description);
    readonly title = input<string>(ESTIMATOR_INTRODUCTION_INITIAL_STATE.title);

    readonly stateChange = output<EstimatorIntroductionState>();

    readonly state = this.#store.state;

    #lastEmittedState: EstimatorIntroductionState | null = null;

    readonly syncStoreFromInputs = effect(() => this.#syncStoreFromInputs(), { injector: this.#injector });

    readonly emitStateChanges = effect(
        () => {
            const nextState = this.state();
            const previousState = this.#lastEmittedState;

            if (previousState !== null && areEstimatorIntroductionStatesEqual(previousState, nextState)) {
                return;
            }

            this.#lastEmittedState = nextState;
            this.stateChange.emit(nextState);
        },
        { injector: this.#injector }
    );

    #syncStoreFromInputs() {
        const patch = {
            description: this.description(),
            title: this.title(),
        };

        untracked(() => this.#store.setState(patch));
    }
}
